import initState from "./state";

const reducer = (state = initState, action) => state;

export default reducer;



// WEBPACK FOOTER //
// ./src/store/auth/reducer.js